import { ReactNode } from 'react';
import tw from 'tailwind-styled-components';
import { DictionaryService, type DictionaryItem } from 'service/dictionary/dictionaryService';
import { SimpleList } from '../SimpleList';

const Container = tw.div`
  mt-10
`;

export const RecipeHint = ({
  recipe,
  copy,
}: {
  recipe: any;
  copy: DictionaryItem[];
}): ReactNode => {
  const hints = recipe.ClassicInstruction.Hints.map((hint: any) => ({
    title: hint.Title,
    list: [hint.Text],
  }));

  return (
    <Container>
      {hints?.length ? (
        <SimpleList
          title={DictionaryService.getCopy('hints', copy)}
          data={hints}
          data-test="hints"
        />
      ) : (
        ''
      )}
    </Container>
  );
};
